import React from 'react';
import Util from '../Util';

class Kskdb extends React.Component {
  render() {
    let hostInfo = this.props.hostInfo;
    let kskdb = hostInfo.kioskInfo.kskdb || {};
    let kioskloc = kskdb.kioskloc || {};
    let kskcfg = kskdb.kskcfg || {};

    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 30, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>kskdb</div>
        </div>

        <div className='info-card pure-u-6-24'>
          <span>Kiosk Name:</span>
          {kioskloc.name} <div style={{ fontSize: 12 }}>{kioskloc.id}</div>
        </div>
        <div className='info-card pure-u-12-24'>
          <span>Location:</span>
          {kioskloc.locationName}
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Org:</span>
          {kioskloc.orgName}
        </div>

        <div className='info-card pure-u-6-24'>
          <span>TerminalId 1:</span>
          {kioskloc.terminalid}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Processor 1:</span>
          {kioskloc.processor1}
        </div>
        <div className='info-card pure-u-12-24'>
          <span>TerminalId 2:</span>
          {kioskloc.terminalid2}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Processor 2:</span>
          {kioskloc.processor2}
        </div>

        <div className='info-card pure-u-6-24'>
          <span>sfecfg Services:</span>
          {hostInfo.sfecfgServices}
        </div>
        <div className='info-card pure-u-6-24'>
          <span>System Type:</span>
          {kioskloc.system}
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Scale Type:</span>
          {kioskloc.scale}
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Timezone:</span>
          {kioskloc.timezone}
        </div>

        <div className='info-card pure-u-8-24'>
          <span>serverurl:</span>
          {kskcfg.serverurl}
          {!hostInfo.kskcfgUsingProdServerUrl && (
            <div style={{ fontSize: 12, color: 'red' }}>Not Prod URL</div>
          )}
        </div>
        <div className='info-card pure-u-8-24'>
          <span>tally_serverurl:</span>
          {kskcfg.tally_serverurl}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>ksk.dbx:</span>
          {kskcfg['ksk.dbx']}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>sales.dbx:</span>
          {kskcfg['sales.dbx']}
        </div>
        <div className='info-card pure-u-2-24'>
          <span>cc.dbx:</span>
          {kskcfg['cc.dbx']}
        </div>

        <div className='info-card pure-u-8-24'>
          <span>printapiurl:</span>
          {kskcfg.printapiurl}
        </div>
        <div className='info-card pure-u-8-24'>
          <span>payapiurl:</span>
          {kskcfg.payapiurl}
        </div>
        <div className='info-card pure-u-8-24'>
          <span>salesapiurl:</span>
          {kskcfg.salesapiurl}
        </div>
      </div>
    );
  }
}

export default Kskdb;



// WEBPACK FOOTER //
// ./src/components/Kskdb.js